import React from 'react';
import { MdArticle, MdGavel } from 'react-icons/md';

function MediaState() {
  return (
    <div className="min-h-screen bg-gray-50 pt-24 pb-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl flex items-center justify-center">
             <MdArticle className="mr-3 text-red-600" />
            Today's State of Media
          </h1>
          <p className="mt-4 text-xl text-gray-500">
            Current Challenges and Ethical Standards
          </p>
        </div>

        <div className="bg-white shadow-lg rounded-lg overflow-hidden mb-10">
            {/* Banner Image */}
            <div className="w-full h-64 bg-gray-200 flex items-center justify-center text-gray-500">
                <img 
                    src="https://images.unsplash.com/photo-1504711331083-9c895941bf81?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" 
                    alt="State of Media" 
                    className="w-full h-full object-cover"
                />
            </div>
            <div className="p-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">
                    The truth being morphed – Medias becoming party properties
                </h2>
                <div className="text-gray-700 space-y-4 leading-relaxed text-justify">
                    <p>
                        In fact there are so many problems with the people that has to be brought out 24 hours a day, 7 days of the week. Cauvery problem, betrayal of political parties, foreign investments which come to destroy us, ever troubling power cuts, price rise of food products, gas, groceries, house rent, educational fees, medical expenses, real estate, financial fraud , dowry, religious fights, caste fights, increasing work hours, deteriorating environment …. Such thousands of new problems are threatening the people everyday. The channels are just trying to sensationalize things hiding the foundation of these problems.
                    </p>
                    <p>
                        The Reason is that the corporate companies belonging to political party leaders invest in the press and the media and direct them. Political parties also publish their own newspapers. They are also running many TV channels competing with one another.
                    </p>
                    <p>
                        The main reason for the political parties to own newspapers and media is to advertise their leaders and the conferences that they hold. In the newspapers and media companies run by the political parties the journalist and the media person's right to speech and right to write, and media ethics are thwarted. The confidence on journalists and media has started to reduce amidst the people, the reason for this is political intervention in the press and media.
                    </p>
                    <p>
                        For example the recently released Tamil movie has clearly picturised how a politician and a central minister who is responsible for press and media is restricting the press and media. The name of that Tamil movie is <span className="font-semibold italic">“Arimanambi”</span>. When you get a chance please don't fail to watch this movie because this movie has not just pointed out the mistakes, it has also picturised in the best manner the special qualities of the media.
                    </p>
                    <p>
                        Every citizen can become an honest reporter. It has been taught to us that we can win over injustice. Not only that they have also picturised how the true news can be brought to the people through electronic media inspite of the restrictions posed by the politicians. As I have already mentioned before, the confidence on the press people and media personalities have stared to decrease. People have started to doubt whether the articles or news that they write are really true.
                    </p>
                    <p>
                        The lie becomes the headlines and the truth is in a box news. The truth is buried so that nobody comes to know of it. The press and media run by corporate companies belonging to politicians produce market stories that tells their histories, a poet's imaginary stories, a new writer quoting from history practically drive their ideas deeply in the minds of people with their ability to write. Because of this caste based, religion based riots happen and societal deterioration happens.
                    </p>
                </div>
            </div>
        </div>

        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
            <div className="bg-blue-600 px-8 py-4">
                <h2 className="text-2xl font-bold text-white flex items-center">
                    <MdGavel className="mr-3" />
                    NAI Code of Ethics
                </h2>
            </div>
            <div className="p-8">
                <ul className="space-y-4">
                    {[
                        { title: "Principles of Reporting", link: "#" }, // Placeholder links or internal routes
                        { title: "Research", link: "#" },
                        { title: "Freedom of the Press", link: "#" },
                        { title: "Independence of Reporting", link: "#" },
                        { title: "Code of Ethics", link: "#" },
                        { title: "Criteria & Rules and Regulations", link: "#" }
                    ].map((item, index) => (
                        <li key={index} className="flex items-center">
                            <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                            <a href={item.link} className="text-lg text-gray-700 hover:text-blue-600 hover:underline transition-colors">
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>

      </div>
    </div>
  );
}

export default MediaState;
